"use client";

import "./accordion.css";
import MuiAccordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { SyntheticEvent, useState } from "react";

export type AccordionProps = {
  data: {
    title: string;
    content: string;
  }[];
};

export const Accordion = ({ data }: AccordionProps) => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <div className="accordion-container">
      {data.map((item) => (
        <MuiAccordion
          expanded={expanded === item.title}
          onChange={handleChange(item.title)}
          key={item.title}
          disableGutters
          elevation={0}
          square
        >
          <AccordionSummary id={item.title}>
            <div className="accordion-summary">
              <span>{item.title}</span>
              <img
                src="/assets/icons/chevron.svg"
                alt=""
                style={{
                  transition: "all 0.3s",
                  transform: `rotate(${
                    expanded === item.title ? "0" : "180"
                  }deg)`,
                }}
              />
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div
              dangerouslySetInnerHTML={{ __html: item.content }}
              className="accordion-details"
            ></div>
          </AccordionDetails>
        </MuiAccordion>
      ))}
    </div>
  );
};
